<template>
  <div>
    <status-page :statusPageType="2" ></status-page>
  </div>
</template>
<script>
  import StatusPage from "./StatusPage.vue"
  export default {
    components: {
      StatusPage
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/DataUpdates.vue